import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { 
    Switch, LoadMore, Form, FormCell, CellBody, CellFooter, Radio, Dialog
} from 'react-weui'
import { WKVisible } from '../../components/wk'
import * as liveroomSetAct from '../../actions/liveroomSettingLecture'


class Move extends React.Component {
    renderChannelRadios(radios) {
        if (!radios) return <LoadMore loading>正在加载</LoadMore>
        if (radios.length === 0) return <p className='text-center'>暂无专栏</p>
        return radios.map(item => {
            return (
                <FormCell radio key={item.id}>
                    <CellBody>{item.name}</CellBody>
                    <CellFooter>
                        <WKVisible create={item.id == this.props.moveToChannelId}>
                            <Radio defaultChecked onChange={e => this.props.setMoveToChannelId(e.target.value)} name='moveToChannel' value={item.id} />
                        </WKVisible>
                        <WKVisible create={item.id != this.props.moveToChannelId}>
                            <Radio onChange={e => this.props.setMoveToChannelId(e.target.value)} name='moveToChannel' value={item.id} />
                        </WKVisible>
                    </CellFooter>
                </FormCell>
            )
        })
    }
    onClickMoveToChannelOk () {
        const lectureId = this.props.currentLecture.id
        const channelId = this.props.moveToChannelId
        if (!lectureId || !channelId) {
            return alert('请先选择专栏')
        }
        this.props.postLectureToChannel(
            this.props.currentLecture.id, this.props.moveToChannelId, this.props.isShowAtList, 
            this.props.lectureKeyword, this.props.liveroomId,
        )
        this.props.setIsShowMoveChannels(false)
    }
    render() {
        return (
            <Dialog className='move-channel-dialog' type="ios" title='移动课程至专栏' show={this.props.isShowMoveChannels} buttons={[{
                label: '取消',
                type: 'default',
                onClick: () => this.props.setIsShowMoveChannels(false),
            }, {
                label: '确定',
                onClick: (e) => this.onClickMoveToChannelOk(e),
            }]}>
                <div className="popup-body">
                    <Form radio>
                        <div className="channels-radio-wrap">
                            {this.renderChannelRadios(this.props.channels)}
                        </div>
                        <div className="channels-switch-wrap">
                            <FormCell switch className='channels-switch'>
                                <CellBody>专栏课程显示在直播间课程列表</CellBody>
                                <CellFooter>
                                    <Switch checked={this.props.isShowAtList} onChange={e => this.props.setIsShowAtList(e.target.checked)} name='isShowAtList' />
                                </CellFooter>
                            </FormCell>
                        </div>
                    </Form>
                </div>
            </Dialog>
        )
    }
}


export default connect(state => ({
    isShowMoveChannels: state.liveroomSettingLecture.isShowMoveChannels,
    channels: state.liveroomSettingLecture.channels,
    currentLecture: state.liveroomSettingLecture.currentLecture,
    lectureKeyword: state.liveroomSettingLecture.lectureKeyword,
    currentLectureInfo: state.liveroomSettingLecture.currentLectureInfo,
    moveToChannelId: state.liveroomSettingLecture.moveToChannelId,
    isShowAtList: state.liveroomSettingLecture.isShowAtList,
}), dispatch => bindActionCreators({ ...liveroomSetAct }, dispatch))(Move)


// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/LectureListMoveChannelDialog.js